module.exports = __webpack_public_path__ + "static/media/directions.4a3bdb7f.svg";